import { Grid, GridItem, Spacer } from "@chakra-ui/react";

import {
  DatePickerFormInput,
  NumberFormInput,
  TextFormInput,
} from "components/inputs";
import { ProductSelectFormInput } from "components/ProductSelect";
import { mobileStyleBreakpoint } from "util/styleHelpers";

const columns = mobileStyleBreakpoint("repeat(1, 1fr)", "repeat(4, 1fr)");
const colSpan = mobileStyleBreakpoint(1, 2);

const BasicContractInfoInputs = ({ uom }: { uom: string | undefined }) => (
  <Grid templateColumns={columns} gap={4} px={4}>
    <GridItem colSpan={colSpan}>
      <ProductSelectFormInput id="product" />
    </GridItem>
    <GridItem>
      <DatePickerFormInput id="startShipDate" label="Starting Ship Date" />
    </GridItem>
    <GridItem>
      <DatePickerFormInput id="endShipDate" label="Ending Ship Date" />
    </GridItem>
    <GridItem>
      <NumberFormInput id="quantity" label="Quantity" min={1} uom={uom} />
    </GridItem>
    <GridItem>
      <TextFormInput id="poNumber" label="PO # (optional)" />
    </GridItem>
    <GridItem colSpan={colSpan}>
      <Spacer />
    </GridItem>
  </Grid>
);

export default BasicContractInfoInputs;
